<router-outlet>
    <div *ngIf="isLoading" class="flex justify-center items-center min-h-screen overflow-hidden">
        <app-spinner></app-spinner>
    </div>
</router-outlet>